import { buildQueryString } from '../helper/utils/utils';
interface AppRoutes {
  "opt-me-out": {
    base: string;
    title: string;
  }
  "mec-opt-in": {
    base: string;
    title: string;
  }
  "mec-opt-out": {
    base: string;
    title: string;
  }
  "service-opt-out": {
    base: string;
    title: string;
  }
  "opt-me-in": {
    base: string;
    title: string;
  }
  download: {
    base: string;
    title: string;
  }
  auth: {
    base: string;
    title: string;
    login: string;
    forgotPassword: string;
    changePassword: string;
    resetPassword: string;
    selectOrganization: string;
  };
  employer: {
    base: string;
    title: string;
    list: string;
    details: string;
    agent: string;
    componentDetail: string;
    detailsWithId: (id: number | string) => (string | number)[];
    detailWithSingleId: (id: number | string) => string;
    agentQuery: (employerId: number, agentId: number) => (string);
    componentDetailWithId: (id: number | string, componentKey: string) => (string | number)[];
  };
  employees: {
    base: string;
    title: string;
    list: string;
    edit: string;
    add: string;
    details: string;
  };
  agent: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  vendor: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  admin: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  payroll: {
    base: string;
    title: string;
    list: string;
    details: string;
    add: string;
    edit: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  census: {
    base: string;
    title: string;
    list: string;
    details: string;
    add: string;
    edit: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  boarding: {
    base: string;
    title: string;
    list: string;
    details: string;
    add: string;
    edit: string;
    sendContract: (id: number | string) => (string | number)[];
    markContractSign: (id: number | string) => (string | number)[];
    detailsWithId: (id: number | string) => (string | number)[];
  };
  mec: {
    base: string;
    title: string;
    list: string;
    details: string;
    add: string;
    edit: string;
  };
  optout: {
    base: string;
    title: string;
    list: string;
    details: string;
    add: string;
    edit: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  mecEnrollments: {
    base: string;
    title: string;
    list: string;
    add: string;
  };
  enrollments: {
    base: string;
    title: string;
    list: string;
    add: string;
  };
  reports: {
    base: string;
    title: string;
    list: string;
  };
  commissions: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithQuery: (params?: Record<string, string | number>) => string;
    subemployerCommissions: string;
    subEmployerDetailsWithQuery: (
      params?: Record<string, string | number>
    ) => string;
    employeeCommissions: string;
    employeeCommissionWithQuery: (
      params?: Record<string, string | number>
    ) => string;
  };
  learnMore: {
    title: string;
    base: string;
    single: (token: string) => (string | number)[];
  };
  settings: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  fallback: {
    base: string;
    title: string;
    default: string;
    notFound: string;
  };
}

export const APP_ROUTES: AppRoutes = {
  download: {
    base: 'download',
    title: 'Download File',
  },
  "opt-me-out": {
    base: 'opt-me-out',
    title: 'Optout',
  },
  "mec-opt-in": {
    base: 'mec-opt-in',
    title: 'MEC Enrollment',
  },
  "mec-opt-out": {
    base: 'mec-opt-out',
    title: 'MEC Opt-Out',
  },
  "service-opt-out": {
    base: 'service-opt-out',
    title: 'Service Opt-Out',
  },
  "opt-me-in": {
    base: 'dnq-opt-in',
    title: 'Optin Benifits',
  },
  auth: {
    base: 'auth',
    title: 'Authentication',
    login: 'login',
    forgotPassword: 'forgot-password',
    changePassword: 'change-password',
    resetPassword: 'reset-password',
    selectOrganization: 'select-organization',
  },
  employer: {
    base: 'employer',
    title: 'Employers',
    list: 'list',
    details: ':id',
    agent: 'employer/agent',
    detailWithSingleId: (id: number | string) => `employer/${id}`,
    agentQuery: (employerId: number, agentId: number) => `employer/agent?employer=${employerId}&agent=${agentId}`,
    detailsWithId: (id: number | string) => ['employer', id],
    componentDetail: ':id/components/:componentKey',
    componentDetailWithId: (id: number | string, componentKey: string) => [
      'employer',
      id,
      'components',
      componentKey,
    ],
  },
  employees: {
    base: 'employees',
    title: 'Employee',
    add: 'add',
    list: 'list',
    edit: 'edit',
    details: ':id',
  },
  agent: {
    base: 'agent',
    title: 'Agents',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['agent', id],
  },
   vendor: {
    base: 'vendor',
    title: 'Vendors',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['vendor', id],
  },
  admin: {
    base: 'admin',
    title: 'Manage Admins',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['admin', id],
  },
  payroll: {
    base: 'payroll',
    title: 'Payroll Actuals',
    list: 'list',
    add: 'add',
    edit: 'edit',
    details: ':id',
    detailsWithId: (id: number | string) => ['edit', id],
  },
  census: {
    base: 'census',
    title: 'Census',
    list: 'list',
    add: 'add',
    edit: 'edit',
    details: ':id',
    detailsWithId: (id: number | string) => ['edit', id],
  },
  boarding: {
    base: 'boarding',
    title: 'Onboarding',
    list: 'list',
    add: 'add',
    edit: 'edit',
    details: ':id',
    sendContract: (id: number | string) => ['edit', id],
    markContractSign: (id: number | string) => ['edit', id],
    detailsWithId: (id: number | string) => ['edit', id],
  },
  mec: {
    base: 'mec',
    title: 'MEC Enrollments',
    list: 'list',
    add: 'add',
    edit: 'edit',
    details: ':id',
  },
  optout: {
    base: "optout",
    title: 'Opt-outs',
    list: "list",
    details: "details",
    add: "add",
    edit: "edit",
    detailsWithId: (id: number | string) => ['edit', id],
  },
  mecEnrollments: {
    base: 'mec-enrollments',
    title: 'MEC Enrollments',
    list: 'list',
    add: 'add',
  },
  enrollments: {
    base: 'enrollments',
    title: 'Enrollments',
    list: 'list',
    add: 'add',
  },
  reports: {
    base: "reports",
    title: 'Reports',
    list: "list",
  },
  commissions: {
    base: 'commissions',
    title: 'Commissions',
    list: 'list',
    details: 'commission-details',
    subemployerCommissions: 'subemployer-commission-details',
    detailsWithQuery: (params?: Record<string, string | number>) =>
      `commission-details${buildQueryString(params)}`,
    subEmployerDetailsWithQuery: (params?: Record<string, string | number>) =>
      `subemployer-commission-details${buildQueryString(params)}`,
    employeeCommissions: 'employee-commission-details',
    employeeCommissionWithQuery: (params?: Record<string, string | number>) =>
      `employee-commission-details${buildQueryString(params)}`,
  },
  learnMore: {
    title: 'Learn More',
    base: 'learn-more',
    single: (token: string) => ['token', token],
  },
  settings: {
    base: 'settings',
    title: 'Settings',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['settings', id],
  },
  fallback: {
    base: '',
    title: 'Home',
    default: '',
    notFound: '**',
  },
};
